import { getMMT_HLD_OBJ } from '../../../common/utils/appUtils';
import {
  dateFormatter,
  formatURLDate,
  isAgentLoggedIn,
  isValidDate,
} from '../../../common/utils/browserUtils';
import { getRoomFromParams } from '../../../common/utils/formattingUtils';
import {
  getAllUrlParams,
  getReqDataSsr,
  getCriterias,
  getSortersCriterias,
} from '../../helpers/utils';
import {
  SET_GROUP_METADATA,
  SET_GROUP_METADATA_IS_LOADING,
} from '../constants/groupMetaDataConstants';
import { getGroupMetaData } from '../services/groupMetaDataService';

export const getGroupMetaDataAction = requestParam => async (dispatch, getState) => {
  const { metadata } = getState();
  // eslint-disable-next-line no-undef
  const queryParams = ssr.isOnClient ? getAllUrlParams() : getReqDataSsr(requestParam);
  const searchText = isAgentLoggedIn() ? queryParams?.searchText : '';

  const listingRedirection = metadata?.listingRedirection;
  const listingFilters = metadata?.listingFilters;
  const listingSorters = metadata?.listingSorters;
  const criterias = getCriterias(listingFilters);
  const sorterCriterias = getSortersCriterias(listingSorters);

  const params = {
    departureCity: queryParams.depCity || 'New Delhi',
    destinationCity: queryParams.dest,
    criterias,
    sorterCriterias,
    apiPokus: getMMT_HLD_OBJ()?.apiPokusListing,
    searchText,
  };

  if (isValidDate(queryParams?.dateSearched)) {
    params.packageDate = dateFormatter(formatURLDate(queryParams?.dateSearched), 'YYYY-MM-DD');
  }

  if (queryParams.campaign) {
    params.campaign = queryParams.campaign;
  }

  if (queryParams?.rooms) {
    params.rooms = getRoomFromParams(queryParams?.rooms);
  }

  if (queryParams?.cmp) {
    params.cmp = queryParams.cmp;
  }

  if (
    !queryParams.packageIds &&
    !listingRedirection &&
    queryParams?.redirectionPage !== 'listing'
  ) {
    dispatch({
      type: SET_GROUP_METADATA_IS_LOADING,
      payload: true,
    });
    try {
      const response = await getGroupMetaData(params);

      if (response.data.success) {
        const { groupDetailsList, listingRedirection } = response.data;
        dispatch({
          type: SET_GROUP_METADATA,
          payload: { groupDetailsList, listingRedirection },
        });
      }

      dispatch({
        type: SET_GROUP_METADATA_IS_LOADING,
        payload: false,
      });
    } catch (e) {
      dispatch({
        type: SET_GROUP_METADATA_IS_LOADING,
        payload: false,
      });
    }
  } else {
    dispatch({
      type: SET_GROUP_METADATA_IS_LOADING,
      payload: false,
    });
  }
};
